const currencySettings = {
  USD: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
  },
  CAD: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
  },
  AUD: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
  },
  GBP: {
    symbol: '£',
    subunitToUnit: 100,
    precision: 2,
  },
  EUR: {
    symbol: '€',
    subunitToUnit: 100,
    precision: 2,
  },
  JPY: {
    symbol: '¥',
    subunitToUnit: 1,
    precision: 0,
  },
  NZD: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
  },
  MXN: {
    symbol: '$',
    subunitToUnit: 100,
    precision: 2,
  },
};

class Currency {
  static get(currencyCode) {
    return currencySettings[currencyCode];
  }

  static isInternational(currencyCode) {
    return currencyCode !== 'USD';
  }
}

export default Currency;




// WEBPACK FOOTER //
// ./javascripts/components/shared/currency.js